import React, { useEffect, useState } from 'react';
import api from './services/api';

export default function ThemaLaag() {
  const [thema, setThema] = useState(null);

  const laad = () => {
    (localStorage.getItem('token') ? api.get('/themas/actief') : new Promise(() => {}))
      .then(r => setThema(r.data?.thema || null))
      .catch(() => {});
  };
  useEffect(() => { laad(); }, []);

  useEffect(() => {
    if (thema?.accent) {
      document.documentElement.style.setProperty('--thema-accent', thema.accent);
      if (thema.accent2) document.documentElement.style.setProperty('--thema-accent2', thema.accent2);
    }
    return () => {
      document.documentElement.style.removeProperty('--thema-accent');
      document.documentElement.style.removeProperty('--thema-accent2');
    };
  }, [thema]);

  const zetUit = async () => {
    setThema(null); // meteen weg
    try { await api.post('/themas/mijn-voorkeur', { zichtbaar: false }); } catch (e) {}
  };

  if (!thema) return null;
  return <ThemaEffect thema={thema} onUit={zetUit} />;
}

function ThemaEffect({ thema, onUit }) {
  const [deeltjes, setDeeltjes] = useState([]);

  const emojis = (thema.emojis || '').trim().split(/\s+/).filter(Boolean);
  const effect = thema.effect || 'geen';
  const eff = thema.effect_emoji || (effect === 'sneeuw' ? '\u2744\uFE0F' : '\uD83D\uDC7B');
  const pool = [...emojis, eff].filter(Boolean);
  const intervalMs = Math.max(2000, (Number(thema.interval_sec) || 8) * 1000);

  useEffect(() => {
    if (effect === 'geen' || pool.length === 0) return undefined;
    let teller = 0;
    const spawn = () => {
      const em = pool[Math.floor(Math.random() * pool.length)];
      const id = Date.now() + '-' + (teller++);
      const isVal = effect === 'sneeuw';
      const dur = isVal ? (7 + Math.random() * 5) : (11 + Math.random() * 8);
      const size = isVal ? (16 + Math.random() * 14) : (28 + Math.random() * 16);
      const pos = isVal ? (Math.random() * 95) : (10 + Math.random() * 70);
      const drift = (Math.random() * 80 - 40) + 'px';
      setDeeltjes(d => [...d, { id, em, dur, size, pos, drift, isVal }]);
      window.setTimeout(() => setDeeltjes(d => d.filter(x => x.id !== id)), dur * 1000 + 300);
    };
    spawn();
    const t = window.setInterval(spawn, intervalMs);
    return () => window.clearInterval(t);
  }, [thema.id, effect, intervalMs]);

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9998, overflow: 'hidden' }} aria-hidden="true">
      <style>{`
        @keyframes thema-val { 0%{transform:translateY(-10vh) rotate(0);opacity:0} 10%{opacity:.9} 90%{opacity:.9} 100%{transform:translateY(110vh) translateX(var(--drift,20px)) rotate(360deg);opacity:0} }
        @keyframes thema-zweef { 0%{transform:translateX(-12vw) translateY(0);opacity:0} 12%{opacity:.85} 50%{transform:translateX(50vw) translateY(-6vh)} 88%{opacity:.85} 100%{transform:translateX(112vw) translateY(4vh);opacity:0} }
      `}</style>

      {/* hoek-emoji's + kruisje om uit te zetten (per account) */}
      {emojis.length > 0 && (
        <div style={{ position: 'absolute', top: 8, right: 12, display: 'flex', alignItems: 'center', gap: 8, pointerEvents: 'auto' }}>
          <span style={{ fontSize: 22, opacity: 0.4, letterSpacing: 4 }}>{emojis.join(' ')}</span>
          <button onClick={onUit} title="Thema uitzetten voor mijn account"
            style={{ pointerEvents: 'auto', background: 'rgba(0,0,0,0.25)', color: 'white', border: 'none', borderRadius: '50%', width: 20, height: 20, fontSize: 12, cursor: 'pointer', lineHeight: 1, opacity: 0.5 }}
            onMouseOver={e => e.currentTarget.style.opacity = 1}
            onMouseOut={e => e.currentTarget.style.opacity = 0.5}>&times;</button>
        </div>
      )}

      {deeltjes.map(d => (
        <div key={d.id} style={d.isVal
          ? { position: 'absolute', left: d.pos + 'vw', top: 0, fontSize: d.size, animation: `thema-val ${d.dur}s linear forwards`, '--drift': d.drift }
          : { position: 'absolute', left: 0, top: d.pos + 'vh', fontSize: d.size, animation: `thema-zweef ${d.dur}s ease-in-out forwards` }
        }>{d.em}</div>
      ))}
    </div>
  );
}
